import { endpoints } from "../Api/configs";
import apiClient from "./apiClient";

export const fetchUserBalance = async (accessToken: string) => {
  const bodyParams = {
    accessToken: accessToken,
  };
  return apiClient(endpoints.profile.userBalance, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const beltConvert = async (accessToken: string) => {
  const bodyParams = {
    accessToken: accessToken,
  };
  return apiClient(endpoints.profile.beltConvert, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const getActiveSubscription = async (userID: string) => {
  const bodyParams = {
    userID: userID,
  };
  return apiClient(endpoints.profile.getActiveSubscription, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const fetchPaymentBeltExchange = async (accessToken: string) => {
  return apiClient(endpoints.profile.paymentBeltExchange, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createSubscription = async (
  accessToken: string,
  planId: string
) => {
  const bodyParams = {
    accessToken: accessToken,
    planId: planId,
  };
  return apiClient(endpoints.profile.subscription, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};
export const updateSubscription = async (
  accessToken: string,
  planId: string
) => {
  const bodyParams = {
    accessToken: accessToken,
    planId: planId,
  };
  return apiClient(endpoints.profile.updateSubscription, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};
export const fetchPaymentCreateSession = async (
  accessToken: string,
  tokens: any,
  price: string,
  eventID: string,
  countryCode?: string,
  type?: string,
  screen?: string
) => {
  const bodyParams: any = {
    accessToken: accessToken,
    tokens: tokens,
    price: price,
    eventID: eventID,
    countryCode: countryCode,
  };
  if (type) {
    bodyParams.type = type;
  }
  if (screen) {
    bodyParams.screen = screen;
  }

  return apiClient(endpoints.profile.paymentCreateSession, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};

export const fetchPaymentRequestSell = async (accessToken, payoutDetails) => {
  const bodyParams = {
    accessToken: accessToken,
    payoutDetails: payoutDetails,
  };
  return apiClient(endpoints.profile.paymentRequestSell, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};

export const fetchPaymentRequestConvert = async (
  accessToken,
  conversionDetails
) => {
  const bodyParams = {
    accessToken: accessToken,
    conversionDetails: conversionDetails,
  };
  return apiClient(endpoints.profile.paymentRequestConvert, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};

export const fetchPaymentRequestRefund = async (accessToken, refundDetails) => {
  const bodyParams = {
    accessToken: accessToken,
    refundDetails: refundDetails,
  };
  return apiClient(endpoints.profile.paymentRequestRefund, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};

export const ConvertTokensToBelts = async (
  accessToken,
  quantity,
  beltType,
  token
) => {
  const bodyParams = {
    accessToken: accessToken,
    quantity: quantity,
    beltType: beltType,
    token: token,
  };
  return apiClient(endpoints.profile.paymentTokensToBelts, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};

export const fetchPurchaseSuccess = async (
  sessionId: string,
  accessToken: string
) => {
  const url = `${endpoints.profile.paymentSuccess}?ID=${sessionId}`;
  const bodyParams = {
    accessToken: accessToken,
  };
  return apiClient(url, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      Accept: "application/json",
    },
  });
};

export const processPayment = async (
  sessionId: string,
  accessToken: string
) => {
  const bodyParams = {
    sessionID: sessionId,
    accessToken: accessToken,
  };
  return apiClient(endpoints.profile.processPayment, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};


export const createTransaction = async (accessToken, bodyParams) => {
  // Construct the bodyParams dynamically based on provided input
  const payload = {
    accessToken,
    ...bodyParams, // Dynamically include all properties from bodyParams
  };

  return apiClient(endpoints.profile.transaction, {
    method: "POST",
    body: JSON.stringify(payload), // Pass the dynamically constructed body
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};
export const getTransaction = async (accessToken) => {
  const url = `${endpoints.profile.transaction
    }?accessToken=${encodeURIComponent(accessToken)}`;
  return apiClient(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};
